import { render, staticRenderFns } from "./StepFour.vue?vue&type=template&id=0c6b0de4&scoped=true"
import script from "./StepFour.vue?vue&type=script&lang=js"
export * from "./StepFour.vue?vue&type=script&lang=js"
import style0 from "./StepFour.vue?vue&type=style&index=0&id=0c6b0de4&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c6b0de4",
  null
  
)

export default component.exports